<template>
  <div>
    <section>
      <v-container container--fluid>
        <v-row class="px-4">
          <h1>LineHaul Pricing</h1>
        </v-row>
        <v-row justify="space-between">
          <v-col cols="6" md="3">
            <v-text-field
              label="Search..."
              v-model="search"
              prepend-inner-icon="search"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="selectedDate"
                  label="View rates as of"
                  prepend-inner-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedDate"
                @input="dateMenu = false; refresh()"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <div style="display: flex; justify-content: center; align-items: center">
            <v-btn text @click="refresh" v-if="!isVisible">
              <v-icon color="cyan darken-2">refresh</v-icon>
            </v-btn>
            <div v-if="isVisible" class="load-3">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </div>
          <v-col cols="3" md="1" v-if="editPermission">
            <v-tooltip top color="secondary" >
              <template v-slot:activator="{ on }">
                <v-btn fab dark color="blue lighten-1" @click="createNew" v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new linehaul pricing</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
      <v-data-table
        :search="search"
        :headers="headers"
        :items="renderedLinehaulPrice"
        :loading="loading"
      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers" :key="index">
              {{props.item[header.value]}}
            </td>
            <td v-else style="text-align: center">
              <template v-if="editPermission && !props.item.raw_delete_date">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-icon color="blue" @click="editRow(props.item)" v-on="on">
                      edit
                    </v-icon>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-icon color="red" @click="deleteRow(props.item)" v-on="on" class="pl-1">
                      delete
                    </v-icon>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog
        v-model="linehaulPricingDialog"
        max-width="800px"
      >
        <v-card>
          <v-card-title class="justify-center" style="position: relative">
            <h2>{{editOrCreate}} Linehaul Pricing</h2>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
            <v-container container--fluid grid-list-xl pb-0>
              <v-form
                ref="form"
              >
                <v-row>
                  <v-col cols="6" md="5">
                    <v-autocomplete
                      label="Client name"
                      :items="clients"
                      item-text="name"
                      item-value="id"
                      v-model="client_id"
                    ></v-autocomplete>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" md="5">
                    <v-autocomplete
                      label="Origin Depot"
                      :items="renderedDestinationDepots"
                      item-text="name"
                      item-value="id"
                      v-model="originDepot"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" md="5">
                    <v-autocomplete
                      label="Destination Depot"
                      :items="renderedDestinationDepots"
                      item-text="name"
                      item-value="id"
                      v-model="destDepot"
                    ></v-autocomplete>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" md="5">
                    <v-text-field
                      label="Box_rate"
                      item-text="Box_rate"
                      item-value="id"
                      v-model="box_rate"
                      :rules="[numberRules]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="space-around">

                  <v-col cols="12" md="5">
                    <v-text-field
                      label="Pallet Rate"
                      item-text="Pallet_rate"
                      item-value="id"
                      v-model="pallet_rate"
                      :rules="[numberRules]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      label="Pallet Rate every"
                      item-text="Pallet_rate_every"
                      item-value="id"
                      v-model="pallet_rate_every"
                      :rules="[numberRulesInteger]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="space-around">
                  <v-col cols="12" md="5">
                    <v-text-field
                      label="Trailer Rate"
                      item-text="trailer_rate"
                      item-value="id"
                      v-model="trailer_rate"
                      :rules="[numberRules]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      label="Trailer Rate every"
                      item-text="trailer_rate_every"
                      item-value="id"
                      v-model="trailer_rate_every"
                      :rules="[numberRulesInteger]"
                    ></v-text-field>
                  </v-col>

                </v-row>

                <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                  <v-col cols="12" md="3" class="text-center">
                    <v-btn
                      text
                      @click="linehaulPricingDialog = false"
                      color="blue-grey lighten-2"
                    >Cancel
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="3" class="text-center">
                    <v-btn
                      text
                      @click="performSave"
                      color="blue darken-1"
                    >Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deleteDialog"
        max-width="500px"
      >
        <v-card>
          <v-card-title class="justify-center">
            <h3>ATTENTION</h3>
          </v-card-title>
          <v-card-text class="text-center">
            You are about to delete this line haul pricing. This action cannot be undone. <br>
            Are you sure you want to proceed?
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
            <v-btn text @click="toggleDelete" color="blue darken-1">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "LineHaulPricing",
    components: {},
    data() {
      return {
        headers: [
          {text: 'Id', value: 'id', align: 'center', sortable: true},
          {text: 'Client name', value: 'client_name', align: 'center', sortable: true},
          {text: 'Origin depot name', value: 'origin_depot_name', align: 'center', sortable: true},
          {text: 'Destination depot', value: 'destination_depot_name', align: 'center', sortable: true},
          {text: 'Climate', value: 'climateName', align: 'center', sortable: false},
          {text: 'Box rate', value: 'box_rate', align: 'center', sortable: true},
          {text: 'Pallet rate', value: 'pallet_rate', align: 'center', sortable: true},
          {text: 'Pallet rate every', value: 'pallet_rate_every', align: 'center', sortable: true},
          {text: 'Trailer rate', value: 'trailer_rate', align: 'center', sortable: true},
          {text: 'Trailer rate every', value: 'trailer_rate_every', align: 'center', sortable: true},
          {text: 'Effective Date', value: 'effective_date', align: 'center', sortable: true},
          {text: 'End Date', value: 'delete_date', align: 'center', sortable: true},
          {text: 'Modified By', value: 'user_name', align: 'center', sortable: true},
          {text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ],
        search: '',
        reload: false,
        isVisible: false,
        loading: false,
        deleteDialog:false,
        toBeDeleted:null,
        linehaulPricingDialog:false,
        selectedDate: new Date().toISOString().substr(0, 10),
        dateMenu: false,
        originDepot:null,
        editOrCreate:null,
        climate:null,
        box_rate:null,
        pallet_rate:null,
        pallet_rate_every:null,
        trailer_rate:null,
        trailer_rate_every:null,
        fuel_surcharge:0,
        client_id:null,
        destDepot:null,
        editLinehaulPricing:null,
      }
    },
    methods: {
      createNew() {
        this. editOrCreate = 'New ';
        this.setInput(null);
        this.linehaulPricingDialog = true;
      },
      refresh() {
        setTimeout(() => this.isVisible = false, 1000);
        this.isVisible = true;
        this.reload = !this.reload;
      },
      editRow(item) {
        this. editOrCreate = 'ID ' + item['id'] + ' Edit ';
        this.editLinehaulPricing = item;
        this.setInput(item);
        this.linehaulPricingDialog = true;
      },
      deleteRow(item) {
        this.toBeDeleted = item;
        this.deleteDialog = true;
      },
      toggleDelete(){
        this.PerformDelete();
        this.deleteDialog = false;
      },
      getClimate(lineHauls){
        const climateList = this.climates || [];
        let index;
        for( index in lineHauls){
          const climate = climateList.find(c => c.id === lineHauls[index]['climate_id']);
          lineHauls[index]['climateName'] = climate ? climate.name : 'Unknown';
        }
      },
      updateDataTable() {
        this.reload = !this.reload;
      },
      setInput(val){
        if(val !== null){
          this.client_id = val.client_id;
          this.originDepot = val.origin_depot_id;
          this.destDepot = val.destination_depot_id;
          this.climate = val.climate_id || null;
          this.box_rate = val.box_rate;
          this.pallet_rate = val.pallet_rate;
          this.pallet_rate_every = val.pallet_rate_every;
          this.trailer_rate = val.trailer_rate;
          this.trailer_rate_every = val.trailer_rate_every;
          this.fuel_surcharge = val.fuel_surcharge;
        } else {
          this.client_id = null;
          this.originDepot = null;
          this.destDepot = null;
          this.climate = null;
          this.box_rate = null;
          this.pallet_rate = null;
          this.pallet_rate_every = null;
          this.trailer_rate = null;
          this.trailer_rate_every = null;
          this.fuel_surcharge = null;
        }

      },
      numberRules(val){
        if(val !== null){
          if (val === ''){
            return true;
          } else if(/^(([0-9]+\.[0-9]*[0-9][0-9]*)|([0-9]*[0-9][0-9]*\.[0-9]+)|([0-9]*[0-9][0-9]*))$/.test(val) === false){
            return 'Must be number';
          } else {
            return true;
          }
        } else return true;
      },
      numberRulesInteger(val){
        if(val !== null){
          if (val === ''){
            return true;
          } else if(/^\+?[1-9][0-9]*$/.test(val) === false){
            return 'Must be number';
          } else {
            return true;
          }
        } else return true;

      },
      numberRulesFloat(val){
        if(val !== null){
          if (val === ''){
            return true;
          } else if(/^([0-9]\d*)(\.\d{1,3})?$|^0\.\d{1,3}?$/.test(val) === false){
            return 'Must be more than 0';
          } else {
            return true;
          }
        } else return true;
      },
      validationInput(body){
        if (body.origin_depot_id === null) {
          this.$store.commit('displaySnackbar', 'Please select a origin Depot');
          return false;
        } else if (body.destination_depot_id === null) {
          this.$store.commit('displaySnackbar', 'Please select a destination Depot');
          return false;
        } else {
          return true;
        }
      },
      PerformDelete() {
        axios.delete(process.env.API_URL + '/linehauls/pricing/' + this.toBeDeleted.id,)
          .then((response) => {
            this.toBeDeleted = null;
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Delete successful');
          })
          .catch((error) => {
            this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
          });
      },
      performSave(){
        let body = {};
        if(this.client_id === null) this.client_id = 0;
        body = {
          client_id:this.client_id,
          origin_depot_id:this.originDepot,
          destination_depot_id:this.destDepot,
          climate:this.climate,
          box_rate:this.box_rate,
          pallet_rate:this.pallet_rate,
          pallet_rate_every:this.pallet_rate_every,
          trailer_rate:this.trailer_rate,
          trailer_rate_every:this.trailer_rate_every,
          fuel_surcharge:this.fuel_surcharge
        };

        if(!this.validationInput(body)){
          return false;
        };
        if(this.editLinehaulPricing === null){
          this.createLinehaulPricing(body);
        } else {
          //update
          axios.post(process.env.API_URL + '/linehauls/pricing/'+ this.editLinehaulPricing['id'] + '/updateprice', body,)
            .then((response) => {
              this.updateDataTable();
              this.$store.commit('displaySnackbar', 'Update successful');
            })
            .catch((response) => {
              this.$store.commit('displaySnackbar', 'Update linehaul failed, ' + response);
            });
          this.editLinehaulPricing = null;
          this.linehaulPricingDialog = false;
       }

      },
      createLinehaulPricing(body){
        axios.post(process.env.API_URL + '/linehauls/pricing/newprice', body,)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Create successful');
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'Create linehaul failed, ' + response);
          });
       this.linehaulPricingDialog = false;
      },
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    computed: {
      editPermission() {
        return this.$store.getters['auth/hasPermission']('client_pricing_edit');
      },
      renderedLinehaulPrice(){
        if (this.linehaulPrice === null || this.linehaulPrice === undefined) {
          return [];
        } else {
          this.getClimate(this.linehaulPrice);
          const userMap = {};
          if (this.users && Array.isArray(this.users)) {
            this.users.forEach(u => { userMap[u.id] = u.name || u.email || `User ${u.id}`; });
          }
          return this.linehaulPrice.map(item => ({
            ...item,
            raw_delete_date: item.delete_date,
            delete_date: item.delete_date || '-',
            user_name: item.user_id ? (userMap[item.user_id] || `User ${item.user_id}`) : '-',
          }));
        }
      },
      renderedDestinationDepots(){
        if (this.destinationDepots === null || this.destinationDepots === undefined) {
          return [];
        } else {
          return this.destinationDepots;
        }
      },
      renderedClimates(){
        if (this.climates === null || this.climates === undefined) {
          return [];
        } else {
          return this.climates;
        }
      },
    },
    asyncComputed: {
      async linehaulPrice() {
        if (this.reload || !this.reload || this.selectedDate){
          return await axios.get(process.env.API_URL + '/linehauls/pricing/allpricing', {
              params: { date: this.selectedDate }
            })
            .then((response) => {
              return response.data;
            })
            .catch((response) => {
              return [];
            });
        }
      },
      async destinationDepots() {
        if (this.reload || !this.reload) {
          return await axios.get(process.env.API_URL +'/depots')
            .then((response) => {
              if (response.status === 200) {
                return response.data;
              } else {
                return [];
              }
            })
            .catch((error) => {
              return [];
            });
        }
      },
      async climates() {
        if (this.reload || !this.reload) {
          return await axios.get(process.env.API_URL + '/climates')
            .then((response) => {
              if (response.status === 200) {
                return response.data;
              } else {
                return [];
              }
            })
            .catch((error) => {
              return [];
            });
        }
      },
      async clients() {
        return await axios.get(process.env.API_URL + '/clients')
          .then((response) => {
            return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
          })
          .catch((error) => {
            return [];
          })
      },
      async users() {
        return await axios.get(process.env.API_URL + '/users')
          .then((response) => {
            return response.data;
          })
          .catch(() => {
            return [];
          });
      }
    }
  }
</script>

<style scoped>

::v-deep .v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none!important;
}
.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}
@keyframes loadingC {
0% {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}
.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}

</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/LineHaulPricing.vue